import React from "react";
import propTypes from "prop-types";

const Dropdown = ({name, label, children, ...rest}) => {
    return (
        <form className={`usa-form ${rest.size}`}>
            <label className="usa-label" htmlFor={name}>{label}</label>
            <select className="usa-select" name={name} id={name} value={rest.selected} onChange={rest.handleChange}>
                {children}
            </select>
        </form>
    )
}
export default Dropdown;
Dropdown.propTypes = { 
    name: propTypes.oneOfType([propTypes.string]),
    label: propTypes.oneOfType([propTypes.string]),
    size: propTypes.oneOfType([propTypes.string])
}
Dropdown.defaultProps = {
    name: "",
    label: "",
    size: ""
}